// Cadre "navigateur" pour héberger des captures fidèles de l'app (pas d'illustration abstraite).
export function MockBrowserFrame({ url = "pulse.apollo-business.com", children, className = "" }) {
  return (
    <div className={`rounded-2xl border border-black/10 bg-white shadow-[0_20px_60px_rgb(0,0,0,0.08)] overflow-hidden ${className}`}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-slate-50/80">
        <span className="h-3 w-3 rounded-full bg-[#ff5f57]" />
        <span className="h-3 w-3 rounded-full bg-[#febc2e]" />
        <span className="h-3 w-3 rounded-full bg-[#28c840]" />
        <div className="ml-3 flex-1 text-center">
          <span className="inline-block text-[11px] text-slate-400 bg-white border border-slate-200 rounded-full px-3 py-0.5">{url}</span>
        </div>
      </div>
      <div className="bg-[#FBFAF8]">{children}</div>
    </div>
  );
}
